import { saveCookie, readCookie } from "./cookies";

function SebCookies() {
  document.addEventListener("sebSaveCookie", (e) => {
    const { key, value } = (e as CustomEvent<{ key: string; value: unknown }>).detail;
    saveCookie(key, value);
  });

  document.addEventListener("sebGetCookie", (e) => {
    const { key } = (e as CustomEvent<{ key: string; value: unknown }>).detail;
    if (typeof key !== "string") {
      console.warn("Missing cookie key in the event");
      return;
    }
    document.dispatchEvent(
      new CustomEvent("sebReadCookie", {
        detail: {
          key,
          value: readCookie(key),
        },
      })
    );
  });
}
SebCookies();
